import React, {PureComponent} from "react"

import {FormattedMessage} from "@irati/utils/lang"
import {IconTypes} from "@irati/ui/src/Icon"

import HintText from "../../HintText"

interface Props {
  maxLength?: number,
  value?: string
}

class CharacterCountDown extends PureComponent<Props> {
  static defaultProps: Pick<Props, "maxLength" | "value"> = {
    maxLength: 0,
    value: ""
  }

  calculateRemainingCharacters = () => {
    const {maxLength, value} = this.props

    return value ? maxLength! - value.length : maxLength
  }

  render() {
    const inputCount = this.calculateRemainingCharacters()
    const hasError = typeof inputCount !== "undefined" && inputCount < 0

    return (
      <HintText icon={hasError ? IconTypes.circleAlertFill : IconTypes.info} hasError={hasError}>
        <FormattedMessage id="platform.characterCountDown.charactersRemaining" values={{inputCount}} />
      </HintText>
    )
  }
}

export default CharacterCountDown
